import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';
import {
  DOCUMENT_HISTORY_ACTIONS,
  DOCUMENT_HISTORY_PAGE_SIZE,
  QUERY_KEY_DOCUMENT_HISTORY,
} from '../constants';

export const useDocumentHistory = (annotationId: number, enabled: boolean) =>
  useQuery({
    queryKey: [QUERY_KEY_DOCUMENT_HISTORY, annotationId] as const,
    enabled,
    queryFn: () =>
      api.request(
        endpoints.auditLogs.list({
          objectType: ['annotation'],
          objectId: [annotationId],
          action: DOCUMENT_HISTORY_ACTIONS,
          pageSize: DOCUMENT_HISTORY_PAGE_SIZE,
        })
      ),
    select: data => ({
      ...data,
      // ISO-8601 UTC timestamps sort correctly with plain string comparison,
      // and unlike `Date`, string compare preserves the wire's microsecond
      // precision instead of truncating it to milliseconds.
      results: [...data.results].sort((a, b) =>
        b.timestamp.localeCompare(a.timestamp)
      ),
    }),
    cacheTime: 0,
  });
